import React from "react"
import styled from "styled-components"
import { VerveLogoText } from "./VerveLogoText"

const MainContainer = styled.div`
  color: white;
  font-size: 3rem;
  display: flex;
  align-items: center;
  flex-direction: column;
  line-height: 0;
  font-weight: 300;
  padding-top: 4rem;

  @media (min-width: 26em) {
      flex-direction: row;
      align-items: baseline;
    }

  @media (min-width: 52.75em) {
    font-size: 4rem;
  }
`

const Verve = styled.span`
  font-family: futura-pt, sans-serif;
  font-weight: inherit;
  fill: white;
  margin-bottom: 1.2rem;

  @media (min-width: 26em) {
    margin-bottom: 0rem;
  }
`

const BackSlash = styled.span`
  color: inherit;
  font-size: inherit;
  padding: 0 1rem;
  font-weight: inherit;
  display: none;

  @media (min-width: 26em) {
    display: block;
  }
`

const H1 = styled.h1`
  color: white;
  padding-top: 1.8rem;
  font-weight: inherit;
  text-transform: lowercase;
`

export default function VerveH1({ h1 }) {
  return (
    <MainContainer>
        <Verve>
          <VerveLogoText/>
        </Verve>
        <BackSlash>/</BackSlash>
        <H1>{h1}</H1>
    </MainContainer>
  )
}